import {ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {SubSink} from 'subsink';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TaxonomyFacadeService} from '../taxonomy-facade.service';
import {ActionsSubject} from '@ngrx/store';
import {ofType} from '@ngrx/effects';
import {createTaxonomySuccess} from '../taxonomy.actions';
import {TaxonomyEditData} from '../taxonomy-edit/taxonomy-edit.component';

@Component({
  selector: 'app-taxonomy-create',
  template: `
    <form [formGroup]="formGroup">
      <mat-card>
        <mat-card-title>
          Create Taxonomy
        </mat-card-title>
        <mat-card-content style="width: 100%">
          <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Taxonomy name</mat-label>
            <input matInput #input [formControl]="nameControl" placeholder="Example: emetriq automotive">
          </mat-form-field>
          <app-taxonomy-dropdown *ngIf="data.taxonomy" [taxonomyControl]="parentControl"
                                 [controlLabel]="'Parent taxonomy'">
          </app-taxonomy-dropdown>
        </mat-card-content>
        <mat-card-actions style="display: flex; width: 100%; justify-content: space-between">
          <button mat-stroked-button color="primary" (click)="emitSave()">Save</button>
        </mat-card-actions>
      </mat-card>
    </form>
  `,
  styleUrls: ['./taxonomy-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaxonomyCreateComponent implements OnInit, OnDestroy {
  nameControl = new FormControl();
  parentControl = new FormControl();
  formGroup = new FormGroup({
    name: this.nameControl,
    parent: this.parentControl
  });
  private subSink = new SubSink();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TaxonomyEditData,
    private taxonomyFacade: TaxonomyFacadeService,
    private matDialogRef: MatDialogRef<TaxonomyCreateComponent>,
    private actions: ActionsSubject
  ) {
  }

  ngOnInit(): void {
    this.subSink.sink = this.actions.pipe(
      ofType(createTaxonomySuccess)
    )
      .subscribe(() => this.matDialogRef.close());
    this.nameControl.setValue(this.data.taxonomy?.name || undefined);
    this.parentControl.setValue(this.data.taxonomy?.id || undefined);
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  emitSave() {
    this.taxonomyFacade.create(
      {
        name: this.nameControl.value,
        parentId: this.parentControl.value
      });
  }
}
